import * as ActionTypes from '../ActionTypes';


// Goal Management Actions
export const GetMyGoalAction = (params) => {
    return {
        type: ActionTypes.MY_GOAL_GET_REQUEST,
        params,
    };
};
export const GetManageGoalAction = (params) => {
    return {
        type: ActionTypes.MANAGE_GOAL_GET_REQUEST,
        params,
    };
};

export const AddManageGoalAction = (params, callback) => {
    return {
        type: ActionTypes.MANAGE_GOAL_ADD_REQUEST,
        params,
        callback
    };
};

export const UpdateManageGoalAction = (params, callback) => {
    return {
        type: ActionTypes.MANAGE_GOAL_UPDATE_REQUEST,
        params,
        callback
    };
};

export const DeleteManageGoalAction = (params, callback) => {
    return {
        type: ActionTypes.MANAGE_GOAL_DELETE_REQUEST,
        params,
        callback
    };
};

// Performance log

export const GetPerformanceLogAction = (params) => {
    return {
        type: ActionTypes.PERFORMANCE_LOG_GET_REQUEST,
        params,
    };
};

export const AddPerformanceLogAction = (params, callback) => {
    return {
        type: ActionTypes.PERFORMANCE_LOG_ADD_REQUEST,
        params,
        callback
    };
};

export const UpdatePerformanceLogAction = (params, callback) => {
    return {
        type: ActionTypes.PERFORMANCE_LOG_UPDATE_REQUEST,
        params,
        callback
    };
};

export const DeletePerformanceLogAction = (params) => {
    return {
        type: ActionTypes.PERFORMANCE_LOG_DELETE_REQUEST,
        params,
    };
};